import { lineColors } from "../../../utils";

export const WQ_POINTS_LAYER_ID = "wq-points";
export const WQ_LABELS_LAYER_ID = "wq-points-labels";
export const WQ_SOURCE_ID = "wq-points-source";

export const WQ_POINTS_LAYER = {
  id: WQ_POINTS_LAYER_ID,
  type: "circle",
  source: WQ_SOURCE_ID,
  layout: { visibility: "visible" },
  paint: {
    "circle-radius": [
      "interpolate",
      ["linear"],
      ["zoom"],
      5,
      ["case", ["boolean", ["feature-state", "selected"], false], 9, 4],
      11,
      ["case", ["boolean", ["feature-state", "selected"], false], 13, 8],
      15,
      ["case", ["boolean", ["feature-state", "selected"], false], 19, 14],
    ],
    "circle-color": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      lineColors.yellow,
      // Wells are colored by aquifer completion (color comes from the
      // ui_list_map_aquifer_completion lookup via wq_data_summary, same
      // palette as the interactive map). Fall back to the old flat blue
      // for rows without the aquifer fields.
      ["coalesce", ["get", "aquifer_color"], lineColors.lightBlue],
    ],
    "circle-stroke-width": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      4,
      1,
    ],
    "circle-stroke-color": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      "#FFFFFF",
      "#000",
    ],
  },
};

export const WQ_LABELS_LAYER = {
  id: WQ_LABELS_LAYER_ID,
  type: "symbol",
  source: WQ_SOURCE_ID,
  minzoom: 9,
  layout: {
    visibility: "visible",
    "symbol-placement": "point",
    "text-field": [
      "case",
      ["==", ["coalesce", ["get", "value_text"], ""], ""],
      // No measurement to show — fall back to well name.
      ["get", "well_name"],
      ["get", "is_nd"],
      // Non-detect: "ND" larger on its own line, value smaller below.
      [
        "format",
        "ND\n",
        { "font-scale": 1.25 },
        ["get", "value_text"],
        { "font-scale": 0.85 },
      ],
      // Detect: just the value + unit on one line.
      ["get", "value_text"],
    ],
    "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
    "text-size": 13,
    "text-line-height": 1.1,
    "text-anchor": "top",
    "text-offset": [0, 0.8],
    "text-justify": "center",
    "text-allow-overlap": false,
  },
  paint: {
    "text-color": "#1a1a1a",
    "text-halo-color": "rgba(255, 255, 255, 0.9)",
    "text-halo-width": 2,
    "text-halo-blur": 0.1,
  },
};

export const BASEMAP_STYLES = [
  { url: "satellite-streets-v11", icon: "satellite_alt" },
  { url: "outdoors-v11", icon: "park" },
  { url: "streets-v11", icon: "commute" },
];

export const DEFAULT_MAP_CENTER = [-98.00408, 30.10119];
export const DEFAULT_MAP_ZOOM = 10;
export const DEFAULT_MAP_BASEMAP =
  "mapbox://styles/mapbox/" + BASEMAP_STYLES[0].url;

export const INIT_MAP_CONFIG = {
  style: DEFAULT_MAP_BASEMAP,
  center: DEFAULT_MAP_CENTER,
  zoom: DEFAULT_MAP_ZOOM,
  preserveDrawingBuffer: true,
  attributionControl: true,
};
